// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-blocks[data-v-7889ffb2]{width:100%;padding-top:32px;padding-left:16px;padding-right:16px}@media screen and (min-width: 769px), print{.menu-blocks[data-v-7889ffb2]{display:flex;flex-wrap:wrap}}\n", ""]);
// Exports
module.exports = exports;
